import ModelsPermissions from './ModelsPermissions';

export default ModelsPermissions;
